import { render, staticRenderFns } from "./UserAssetPhones.vue?vue&type=template&id=da1dcb20"
import script from "./UserAssetPhones.vue?vue&type=script&lang=js"
export * from "./UserAssetPhones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports